'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { NotificationProvider } from './components/NotificationContext';
type Props = {
  children: React.ReactNode;
};
export function NotificationProviderWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <NotificationProvider>{children}</NotificationProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}